import type { Client2TrackedTranslation } from '@ps/web-core-intl';
import { isAfter, isBefore, subYears } from 'date-fns';

import {
  TXTWCL_Check_thatXs_correct_and_try_a_ELL,
  TXTWCL_SorryX_something_went_wrongX,
  TXTWCL_SorryX_you_need_to_be_N0_or_ol_ELL,
  TXTWCL_Try_refreshing_the_pageX
} from '../translations';
import type { Error } from '../types';
import type { DateOrPartial } from '../utils/formatting';

interface DateDOBMessage {
  invalidDateMessage?: Client2TrackedTranslation;
  legalAgeMessage?: Client2TrackedTranslation;
}

export const dateDob =
  (
    {
      invalidDateMessage = TXTWCL_Check_thatXs_correct_and_try_a_ELL,
      legalAgeMessage = TXTWCL_SorryX_you_need_to_be_N0_or_ol_ELL
    }: DateDOBMessage,
    legalAge: number | undefined
  ) =>
  (value: DateOrPartial): Error => {
    if (!legalAge) {
      return {
        valid: false,
        message: [TXTWCL_SorryX_something_went_wrongX, TXTWCL_Try_refreshing_the_pageX]
      };
    }

    if (!(value instanceof Date)) {
      return {
        valid: false,
        message: invalidDateMessage
      };
    }

    const today = new Date();

    if (isBefore(value, subYears(today, 110)) || isAfter(value, today)) {
      return {
        valid: false,
        message: invalidDateMessage
      };
    }

    if (isAfter(value, subYears(today, legalAge))) {
      return {
        valid: false,
        message: { ...legalAgeMessage, values: { 0: legalAge } }
      };
    }

    return {
      valid: true
    };
  };
